import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 24 24"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            d="M15.522 13.491c.109.204.207.375.293.552.228.469.349.965.331 1.485-.054 1.572-.98 2.797-2.477 3.303-.31.106-.627.16-.956.159-.735-.003-1.471.027-2.205-.005-1.284-.058-2.285-.63-2.957-1.737a3.206 3.206 0 0 1-.478-1.746.676.676 0 0 1 .628-.683.668.668 0 0 1 .725.573c.011.067.026.136.023.203-.04.852.813 1.954 1.98 1.987.808.023 1.618.043 2.424.003.921-.045 1.744-.848 1.876-1.754.129-.876-.229-1.554-.89-2.088a1.194 1.194 0 0 0-.76-.254 2273.2 2273.2 0 0 1-7.153.001c-.13 0-.263-.011-.39-.038-.314-.065-.556-.382-.535-.687.023-.327.303-.62.622-.65.088-.01.177-.013.267-.013h11.798c.22 0 .44.002.661.012.346.015.618.293.65.652.024.287-.255.639-.561.689a2.69 2.69 0 0 1-.439.033c-.766.002-1.533 0-2.299 0h-.178v.003ZM11.69 5c.503.026 1.02.021 1.528.087 1.454.186 2.719 1.487 2.888 2.937.019.166.034.333.034.5a.66.66 0 0 1-.628.663.684.684 0 0 1-.72-.566c-.039-.231-.055-.47-.124-.692-.254-.82-.82-1.324-1.66-1.463-.48-.079-.982-.057-1.474-.059-.418 0-.842-.002-1.255.054-.854.117-1.716.92-1.811 1.773-.067.595-.003 1.16.389 1.647.066.082.126.169.179.258.187.31.126.636-.156.868a.626.626 0 0 1-.871-.032c-.356-.34-.583-.767-.74-1.225-.726-2.104.649-4.35 2.871-4.667.507-.073 1.025-.058 1.55-.083Z"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
